import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IRole extends IBaseEntity {
    id?: number;
    roleName?: string;
    authorityName?: string;
    editable?: boolean;
}

export class Role extends BaseEntity implements IRole {
    id?: number;
    roleName?: string;
    authorityName?: string;
    editable?: boolean;

    constructor(role?) {
        super();
        if (role) {
            this.id = role.id;
            this.roleName = role.roleName;
            this.authorityName = role.authorityName;
            this.editable = role.editable;
        }
    }

    clone(): Role {
        return new Role(this);
    }
}
